import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { ENTITY_TYPE } from '../Constants';


export const generatePDF = (jsonData) => {
    const doc = new jsPDF();
    doc.text('JSON Data PDF', 20, 10);

    const columns = Object.keys(jsonData[0]);
    const rows = jsonData.map(obj => columns.map(col => obj[col]));
    doc.autoTable({
        head: [columns],
        body: rows,
    });
    doc.save('report data.pdf');
};


// Helper function to format headers
// const formatHeader = (key) => {
//     return key
//         .replace(/_/g, ' ')           // Replace underscores with spaces
//         .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
// };

// Helper function to replace missing or null data with "--"
const handleMissingData = (data) => {
    return data === null || data === undefined ? "--" : data;
};
const getCurrentDateTime = () => {
    const now = new Date();

    // Get date components
    const day = String(now.getDate()).padStart(2, '0'); // Pad single digit days with leading zero
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const year = now.getFullYear();

    // Get time components
    const hours = String(now.getHours()).padStart(2, '0'); // Pad single digit hours
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Pad single digit minutes

    // Format the date and time as desired
    return `${day}/${month}/${year}_${hours}_${minutes}`;
};


const headerMappingTask = [
    { header: 'Srl', key: 'srl', width: 5 },
    { header: 'Start Date', key: 'start_date', width: 20 },
    { header: 'End Date', key: 'end_date', width: 20 },
    { header: 'Duration', key: 'duration', width: 12 },
    { header: 'Task Name', key: 'task_name', width: 50 },
    { header: 'Task Description', key: 'task_description', width: 50 },
    { header: 'Project Name', key: 'project_name', width: 50 },
    { header: 'Task Lead', key: 'lead_name', width: 10 },
    { header: 'Allocate By', key: 'alloc_by_name', width: 10 },
    { header: 'Actual Start Date', key: 'actual_start_date', width: 20 },
    { header: 'Actual End Date', key: 'actual_end_date', width: 20 },
    { header: 'Status', key: 'status', width: 10 },
    { header: 'Comments', key: 'comment', width: 50 },
    { header: 'Delay Days', key: 'delay_days', width: 15 },
    { header: 'Delay Reason', key: 'delay_reason', width: 50 },
];


const headerMappingProject = [
    { header: 'Srl', key: 'srl', width: 5 },
    { header: 'Start Date', key: 'start_date', width: 20 },
    { header: 'End Date', key: 'end_date', width: 20 },
    { header: 'Duration', key: 'duration', width: 12 },
    { header: 'Project Name', key: 'project_name', width: 50 },
    { header: 'Project Description', key: 'project_description', width: 50 },
    { header: 'Project Lead', key: 'lead_name', width: 10 },
    { header: 'Allocate By', key: 'alloc_by_name', width: 10 },
    { header: 'Actual Start Date', key: 'actual_start_date', width: 20 },
    { header: 'Actual End Date', key: 'actual_end_date', width: 20 },
    { header: 'Status', key: 'status', width: 10 },
    { header: 'Comments', key: 'comment', width: 50 },
    { header: 'Delay Days', key: 'delay_days', width: 15 },
    { header: 'Delay Reason', key: 'delay_reason', width: 50 },
];
const headerMappingTotalTaskData = [
    { header: 'Srl', key: 'srl', width: 10 },
    { header: 'User Name', key: 'user_name', width: 20 },
    { header: 'Total', key: 'total_tasks', width: 10 },
    { header: 'Efficiency Percentage \n Done Ok / Done All', key: 'efficiency_percentage', width: 20 },
    { header: 'Done Ok', key: 'done_on_time', width: 10 },
    { header: 'Done \nDelayed', key: 'done_late', width: 10 },
    { header: 'Pending Ok', key: 'pending_on_time', width: 10 },
    { header: 'Pending \nDelayed', key: 'pending_late', width: 10 },
    { header: 'InProgress Ok', key: 'in_progress_late', width: 12 },
    { header: 'InProgress \nDelayed', key: 'in_progress_on_time', width: 10 },
    { header: 'Under \nReview', key: 'under_review', width: 10 },
    { header: 'Cancelled', key: 'cancelled', width: 10 },
];
const headerMappingActivityLog = [
    { header: 'Srl', key: 'ID', width: 10 },
    { header: 'DateTime', key: 'ActionDtTm', width: 20 },
    { header: 'Staff Code', key: 'StaffCode', width: 15 },
    { header: 'Action Type', key: 'ActionType', width: 20 },
    { header: 'Action Description', key: 'ActionDscr', width: 25 },
    { header: 'Entity Type', key: 'EntityType', width: 15 },
    { header: 'Entity ID', key: 'EntityID', width: 10 },
    { header: 'Change Log', key: 'ChangeLog', width: 30 },
    { header: 'From IP', key: 'FromIP', width: 15 },
    { header: 'From Device', key: 'FromDeviceNm', width: 20 },
];

// const formatHeader = (key) => headerMapping[key] || key;
const formatDate = (dateStr) => {
    if (!dateStr) return "--"; // Handle null/undefined cases

    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // If hours is 0, set it to 12 (midnight)

    return `${day}/${month}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
};
function formatTimeDuration(duration) {
    if (!duration) return "--";
    const parts = duration.split(" "); // Split the input string by space
    let days = 0,
        time = "00:00";
    console.log(duration, parts);

    // Extract days and time from the input string
    if (parts.length > 2) {
        days = parseInt(parts[0]);
        time = parts[2];
    } else if (parts.length === 1) {
        if (parts[0].includes(":")) {
            time = parts[0];
        } else {
            days = parseInt(parts[0]);
        }
    }

    // Split time into hours and minutes
    const [hours, minutes] = time.split(":").map(Number);

    // Construct the output based on the specified conditions
    if (days === 0 && hours === 0 && minutes === 0) {
        return "0 days 00:00";
    } else if (days === 0) {
        return ` ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
            } `;
    } else if (hours === 0 && minutes === 0) {
        return ` ${days} ${days === 1 ? "day" : "days"} `;
    } else {
        return ` ${days} ${days === 1 ? "day" : "days"} ${hours < 10 ? "0" + hours : hours
            }:${minutes < 10 ? "0" + minutes : minutes} `;
    }
}

const formatComments = (comments) => {
    let output = [];
    if (!comments) return "--"; // Handle null/undefined cases

    if (comments.Cancel) {
        output.push(`Cancel Comment: ${comments.Cancel}`);
    }
    if (comments.Closing) {
        output.push(`Closing Comment: ${comments.Closing}`);
    }
    if (comments.Rejection) {
        output.push(`Rejection Comment: ${comments.Rejection}`);
    }

    // Join the array with newline characters, or return "--" if no comments were added
    return output.length > 0 ? output.join('\n') : "--";
};

const convertToDDMMYYYY = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};
const capitalizeFirstLetter = (str) => {
    return str
        .split(' ') // Split the string into words
        .map(word => {
            // Capitalize the first letter and concatenate it with the rest of the word
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' '); // Join the words back into a string
};
export const generateExcel = async (jsonData, reportType, appliedFilter, userInfo) => {

    let headerMapping
    let reportHeader
    let endColumn
    const borderStyle = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
    };
    if (appliedFilter.reportStatus === "task_totals") {
        endColumn = 'L';
        reportHeader = headerMappingTotalTaskData
        headerMapping = headerMappingTotalTaskData.reduce((acc, { header, key }) => {
            acc[key] = header; // Assign header value to the key
            return acc;
        }, {});
    }

    else if ('project_description' in jsonData[0]) {
        endColumn = 'N';
        reportHeader = headerMappingProject
        headerMapping = headerMappingProject.reduce((acc, { header, key }) => {
            acc[key] = header; // Assign header value to the key
            return acc;
        }, {});
    } else {
        endColumn = 'O';
        reportHeader = headerMappingTask
        headerMapping = headerMappingTask.reduce((acc, { header, key }) => {
            acc[key] = header; // Assign header value to the key
            return acc;
        }, {});
    }
    if (reportType === "overdue") {
        headerMapping["delay_days"] = "Overdue Days"
    }
    // Create a new workbook and a new worksheet
    const workbook = new ExcelJS.Workbook();

    // Report type
    let heading
    let worksheet
    if (appliedFilter.reportStatus === "task_totals") {
        heading = `User Task Summary`; // Define the heading
        worksheet = workbook.addWorksheet(heading);
    }
    else {
        worksheet = workbook.addWorksheet(capitalizeFirstLetter(`${appliedFilter?.reportStatus} ${appliedFilter?.entity}`));
        heading = `${appliedFilter?.reportStatus} ${appliedFilter.entity} List`; // Define the heading
    }
    const mergedCell = worksheet.getCell('A1');
    worksheet.mergeCells(`A1:${endColumn}1`); // Merge cells A1 to O1
    mergedCell.value = capitalizeFirstLetter(heading);
    worksheet.getRow(1).font = { bold: true, size: 20 }; // Bold font for headers
    worksheet.getRow(1).alignment = { horizontal: 'center' }; // Center the header text
    mergedCell.border = borderStyle
    // Date range
    const rangedMergedCell = worksheet.getCell('A2');
    worksheet.mergeCells(`A2:${endColumn}2`); // Merge cells A1 to O1
    if (appliedFilter.reportStatus === "task_totals") {

        rangedMergedCell.value = {
            richText: [
                { text: 'From ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
                { text: convertToDDMMYYYY(appliedFilter.startDate), font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                { text: ' to ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                { text: `${convertToDDMMYYYY(appliedFilter.endDate)};`, font: { name: 'Calibri', bold: true, size: 16 } },   // Bold date
                { text: ' User: ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                { text: `${appliedFilter?.userFilter.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } },  // Bold date
                { text: 'Allocate : ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                { text: `${appliedFilter?.byOrToMe.toUpperCase().replace(/_/g, ' ')}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            ]
        };
    }
    else {

        rangedMergedCell.value = {
            richText: [
                { text: 'From ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
                { text: convertToDDMMYYYY(appliedFilter.startDate), font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                { text: ' to ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                { text: `${convertToDDMMYYYY(appliedFilter.endDate)}`, font: { name: 'Calibri', bold: true, size: 16 } },   // Bold date
                // { text: ' User: ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                // { text: `${appliedFilter?.userFilter.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } },  // Bold date
                // { text: 'Allocate : ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                // { text: `${appliedFilter?.byOrToMe.toUpperCase().replace(/_/g, ' ')}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            ]
        };
    }
    worksheet.getRow(2).alignment = { horizontal: 'center' }; // Center the header text
    rangedMergedCell.border = borderStyle
    // filter

    if (appliedFilter.reportStatus !== "task_totals") {
        // Merge cells A3 to O3
        const filterMergedCell = worksheet.getCell('A3');
        worksheet.mergeCells(`A3:${endColumn}3`);

        if (appliedFilter.entity === "task") {

            filterMergedCell.value = {
                richText: [
                    { text: 'Task Status: ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
                    { text: `${appliedFilter?.taskStatus.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                    { text: 'User: ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                    { text: `${appliedFilter?.userFilter.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                    { text: 'Allocate : ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                    { text: `${appliedFilter?.byOrToMe.toUpperCase().replace(/_/g, ' ')}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                ]
            };
        }
        else {

            filterMergedCell.value = {
                richText: [
                    { text: 'Project Status: ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
                    { text: `${appliedFilter?.reportStatus.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                    // { text: 'For Lead : ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                    // { text: `Selected / ${appliedFilter?.userFilter.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                    { text: 'Allocate : ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
                    { text: `${appliedFilter?.byOrToMe.toUpperCase().replace(/_/g, ' ')}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
                ]
            };
        }
        filterMergedCell.border = borderStyle
        worksheet.getRow(3).alignment = { horizontal: 'center' }; // Center the header text
    }

    // Step 1: Add headers with styling
    const headers = Object.values(headerMapping);
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
        cell.border = borderStyle;
        cell.alignment = { wrapText: true, vertical: 'top' };
    });
    let tableHeadingRow
    if (appliedFilter.reportStatus === "task_totals") {
        tableHeadingRow = 3
    }
    else {
        tableHeadingRow = 4

    }
    worksheet.getRow(tableHeadingRow).font = { bold: true }; // Bold font for headers

    for (let col = 0; col <= (endColumn.charCodeAt(0) - 'A'.charCodeAt(0)); col++) {
        const columnLetter = String.fromCharCode('A'.charCodeAt(0) + col); // Get column letter
        worksheet.getCell(`${columnLetter}${tableHeadingRow}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'dbe5f1' } // Green background for headers
        };
    }
    worksheet.getRow(2).alignment = { horizontal: 'center' }; // Center the header text


    // Set custom widths for each column
    reportHeader.forEach((header, index) => {
        const col = index + 1; // Excel columns are 1-indexed
        worksheet.getColumn(col).width = header.width; // Set custom width
    });
    // Step 2: Add data rows
    jsonData.forEach(data => {
        const formattedRow = Object.keys(headerMapping).map(key => {
            const value = data[key];

            // Check if the key corresponds to a date field and format it
            if (key === 'start_date' || key === 'end_date' || key === 'actual_start_date' || key === 'actual_end_date') {
                return formatDate(value); // Format the date
            }
            if (key === 'status') {
                console.log(value.text)
                return value?.text;
            }
            if (key === 'efficiency_percentage') {
                return value?.toFixed(2);
            }
            if (key === 'comment') {

                return formatComments(value);
            }

            if (key === 'delay_days' || key === 'duration') {
                return formatTimeDuration(value);
            }


            return handleMissingData(value); // Handle other fields
        });

        const newRow = worksheet.addRow(formattedRow);


        // Apply the border style to each cell in the new row
        newRow.eachCell((cell) => {
            cell.border = borderStyle;
            cell.alignment = { wrapText: true, vertical: 'top', horizontal: "left" };

        });

    });


    // Step 3: Write the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    // Create a link to download the Excel file
    const a = document.createElement('a');
    const crDateTime = getCurrentDateTime()
    a.href = url;
    if (appliedFilter.reportStatus === "task_totals") {
        a.download = `${heading} - ${capitalizeFirstLetter(userInfo?.user_name)} - ${capitalizeFirstLetter(crDateTime)} .xlsx`;
    }
    else {

        a.download = `${capitalizeFirstLetter(reportType)} ${capitalizeFirstLetter(appliedFilter.entity)} - ${capitalizeFirstLetter(userInfo?.user_name)} - ${capitalizeFirstLetter(crDateTime)}.xlsx`;
    }
    a.click();
    window.URL.revokeObjectURL(url);
};
export const generateActiveLogExcel = async (jsonData, reportType, appliedFilter, userInfo) => {

    let headerMapping
    let reportHeader
    let endColumn
    const borderStyle = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
    };
    endColumn = 'J';
    reportHeader = headerMappingActivityLog
    headerMapping = headerMappingActivityLog.reduce((acc, { header, key }) => {
        acc[key] = header; // Assign header value to the key
        return acc;
    }, {});


    // Create a new workbook and a new worksheet
    const workbook = new ExcelJS.Workbook();

    // Report type
    let heading
    let worksheet
    worksheet = workbook.addWorksheet(`${appliedFilter?.userFilter} User Activity`);
    heading = `User Activity`; // Define the heading
    const mergedCell = worksheet.getCell('A1');
    worksheet.mergeCells(`A1:${endColumn}1`); // Merge cells A1 to O1
    mergedCell.value = capitalizeFirstLetter(heading);
    worksheet.getRow(1).font = { bold: true, size: 20 }; // Bold font for headers
    worksheet.getRow(1).alignment = { horizontal: 'center' }; // Center the header text
    mergedCell.border = borderStyle
    // Date range
    const rangedMergedCell = worksheet.getCell('A2');
    worksheet.mergeCells(`A2:${endColumn}2`); // Merge cells A1 to O1


    rangedMergedCell.value = {
        richText: [
            { text: 'From ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
            { text: convertToDDMMYYYY(appliedFilter.startDate), font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            { text: ' to ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
            { text: `${convertToDDMMYYYY(appliedFilter.endDate)}`, font: { name: 'Calibri', bold: true, size: 16 } },   // Bold date
        ]
    };
    worksheet.getRow(2).alignment = { horizontal: 'center' }; // Center the header text
    rangedMergedCell.border = borderStyle
    // Merge cells A3 to O3
    const filterMergedCell = worksheet.getCell('A3');
    worksheet.mergeCells(`A3:${endColumn}3`);


    filterMergedCell.value = {
        richText: [
            { text: 'Action Type: ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
            { text: `${appliedFilter?.actionType.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            { text: 'Entity Type: ', font: { name: 'Calibri', bold: false, size: 16 } }, // Normal font
            { text: `${getEntityValueById(appliedFilter?.entityType).toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            { text: 'User: ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
            { text: `${appliedFilter?.userFilter.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
            { text: 'Entity Id: ', font: { name: 'Calibri', bold: false, size: 16 } },  // Normal font
            { text: `${appliedFilter?.entityId?.toString()?.toUpperCase()}; `, font: { name: 'Calibri', bold: true, size: 16 } }, // Bold date
        ]
    };

    filterMergedCell.border = borderStyle
    worksheet.getRow(3).alignment = { horizontal: 'center' }; // Center the header text

    // Step 1: Add headers with styling
    const headers = Object.values(headerMapping);
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
        cell.border = borderStyle;
        cell.alignment = { wrapText: true, vertical: 'top' };
    });
    let tableHeadingRow
    tableHeadingRow = 4

    worksheet.getRow(tableHeadingRow).font = { bold: true }; // Bold font for headers

    for (let col = 0; col <= (endColumn.charCodeAt(0) - 'A'.charCodeAt(0)); col++) {
        const columnLetter = String.fromCharCode('A'.charCodeAt(0) + col); // Get column letter
        worksheet.getCell(`${columnLetter}${tableHeadingRow}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'dbe5f1' } // Green background for headers
        };
    }
    worksheet.getRow(2).alignment = { horizontal: 'center' }; // Center the header text


    // Set custom widths for each column
    reportHeader.forEach((header, index) => {
        const col = index + 1; // Excel columns are 1-indexed
        worksheet.getColumn(col).width = header.width; // Set custom width
    });
    // Step 2: Add data rows
    jsonData.forEach((data, index) => {
        const formattedRow = Object.keys(headerMapping).map((key) => {
            const value = data[key];

            // Check if the key corresponds to a date field and format it
            if (key === 'ActionDtTm') {
                return formatDate(value); // Format the date
            }
            if (key === 'ID') {
                return index + 1; // Format the date
            }
            if (key === 'EntityType') {
                if (getEntityValueById(value) === "ALL") {

                    return "--"; // Format the date
                }
                return getEntityValueById(value); // Format the date
            }
            return handleMissingData(value); // Handle other fields
        });

        const newRow = worksheet.addRow(formattedRow);


        // Apply the border style to each cell in the new row
        newRow.eachCell((cell) => {
            cell.border = borderStyle;
            cell.alignment = { wrapText: true, vertical: 'top', horizontal: "left" };

        });

    });


    // Step 3: Write the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    // Create a link to download the Excel file
    const a = document.createElement('a');
    const crDateTime = getCurrentDateTime()
    a.href = url;
    a.download = `User Activity - ${appliedFilter?.userFilter} - ${capitalizeFirstLetter(crDateTime)}.xlsx`;

    a.click();
    window.URL.revokeObjectURL(url);
};

export function getEntityValueById(id) {
    console.log(id)
    const entity = ENTITY_TYPE.find(item => parseInt(item.id) === parseInt(id));
    console.log(entity)

    return entity ? entity.value : "ALL"; // Returns `null` if id not found
}